<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <image-row />
      </v-row>
      <div class="intro-wrapper">
        <div class="intro-content">
          <div class="intro-subtitle-text-wrapper">
            <span class="intro-subtitle-text">{{ introSubtitle1 }}</span>
          </div>
          <div class="intro-subtitle-text-wrapper">
            <span class="intro-subtitle-text">{{ introSubtitle2 }}</span>
          </div>
        </div>
      </div>
      <div class="apps-cards-wrapper">
        <v-row class="apps-card-grid" no-gutters justify="center">
          <div class="apps-card-grid-column" v-for="(app, index) in showedApps" :key="index">
            <div class="apps-card">
              <v-img class="apps-card-image" eager contain :src="app.src" />
              <div class="apps-card-content">
                <div class="apps-card-title-wrapper">
                  <span class="apps-card-title">{{ learnFreeText }}</span>
                </div>
                <div class="apps-card-text-wrapper">
                  <span :class="'apps-card-text text-' + app.key">{{ app.title }}</span>
                </div>
                <div class="apps-card-badges-wrapper">
                  <div class="apps-card-badges">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" v-if="app.iosId !== null">
                        <v-img eager height="46" contain @click="openAttribution(app.attribution_link_ios)" class="app-card-badge" src="https://storage.googleapis.com/mwm-website-v2-content/apps/download_appstore.svg" />
                      </v-col>
                      <v-col cols="6" v-if="app.androidId !== null">
                        <v-img eager height="46" contain @click="openAttribution(app.attribution_link_android)" class="app-card-badge" src="https://storage.googleapis.com/mwm-website-v2-content/apps/download_playstore.svg" />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-row>
      </div>
      <div class="bottom-wrapper">
        <div class="bottom-title-text-wrapper">
          <span class="bottom-title-text">{{ bottomTitle }}</span>
        </div>
        <div class="bottom-subtitle1-text-wrapper">
          <span class="bottom-subtitle-text">{{ bottomText }}</span>
        </div>
        <div class="bottom-subtitle2-text-wrapper">
          <span class="bottom-subtitle-text">{{ bottomSubText1 }}</span><br />
          <span class="bottom-subtitle-text">{{ bottomSubText2 }}</span>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import SizeHolder from '@/mixins/SizeHolder.vue';

import ImageRow from './components/ImageRowCovid.vue'

export default {
  mixins: [SizeHolder],
  components: {
    'image-row': ImageRow,
  },
  data: () => ({
    introSubtitle2: 'Libérez votre créativité : Guitare, Piano, Batterie ou Beatmaking, voire les quatre en même temps, tout est possible. Vous n’avez plus qu’à vous y mettre !',
    introSubtitle1: 'Le contexte actuel est particulièrement difficile et nous avons plus que jamais besoin de moyens permettant de mieux vivre la situation de confinement à laquelle nous faisons collectivement face.  MWM a ainsi décidé de mettre gratuitement à disposition sa suite d’applications d’apprentissage de la musique, dès à présent et ce jusqu’à une date établie pour l’instant au 31 mai 2020.',

    bottomTitle: '#CreezChezVous, pour encourager la création à la maison.',
    bottomText: 'Pour promouvoir le respect de la distanciation sociale recommandé par l’OMS, MWM a créé le hashtag #CreezChezVous. Ce message est une manière pour les équipes MWM de participer à l’effort général en encourageant les populations à rester chez elles.',
    bottomSubText1: 'Montrez au monde ce que vous savez faire',
    bottomSubText2: '#CreezChezVous',

    androidRoot: 'https://play.google.com/store/apps/details?id=',
    iosRoot: 'https://apps.apple.com/app/id',

    showedApps: [
      { key: 'guitar', title: 'la guitare', attribution_link_android: 'https://go.onelink.me/app/c5bd0555', attribution_link_ios: 'https://go.onelink.me/app/a969e385', iosId: '1365011081', androidId: 'com.mwm.guitar', src: 'https://storage.googleapis.com/mwm-website-v2-content/covid/guitar_img.png' },
      { key: 'piano', title: 'le piano', attribution_link_android: 'https://go.onelink.me/app/daa84344', attribution_link_ios: 'https://go.onelink.me/app/8f1571f', iosId: '1360309966', androidId: 'com.mwm.piano', src: 'https://storage.googleapis.com/mwm-website-v2-content/covid/piano_img.png' },
      { key: 'drums', title: 'la batterie', attribution_link_android: 'https://go.onelink.me/app/2656e9a3', attribution_link_ios: 'https://go.onelink.me/app/b64bf021', iosId: '1381436705', androidId: 'com.mwm.drum', src: 'https://storage.googleapis.com/mwm-website-v2-content/covid/drums_img.png' },
      { key: 'bmp', title: 'le beatmaking', attribution_link_android: 'https://go.onelink.me/app/e0e140f8', attribution_link_ios: 'https://go.onelink.me/app/372570a2', iosId: '1362013798', androidId: 'com.mwm.sampler', src: 'https://storage.googleapis.com/mwm-website-v2-content/covid/bmp_img.png' },
    ],

    learnFreeText: 'Apprendre gratuitement',
  }),
  methods: {
    openStore (type, appID) {
      const url = type === 'android' ? this.androidRoot + appID : this.iosRoot + appID;
      const win = window.open(url, '_blank');
      win.focus();
    },
    openAttribution (link) {
      const win = window.open(link, '_blank');
      win.focus();
    },
  },
  computed: {

  },
  mounted () {

  }
};
</script>

<style scoped lang="scss">
@media (max-width: 960px) {
  .intro-wrapper {
    width: 85%!important;
  }

  .intro-subtitle-text {
    font-size: 14px!important;
  }

  .apps-card-grid {
    grid-template-columns: repeat(1, 1fr)!important;
    grid-gap: 2rem!important;
  }

  .apps-card {
    max-width: 20rem!important;
  }

  .apps-card-content {
    padding: 1.5rem!important;
  }

  .apps-card-text {
    font-size: 30px!important;
  }

  .apps-card-badges-wrapper {
    margin-top: 0!important;
  }

  .app-card-badge {
    height: 2.1rem!important;
  }

  .bottom-wrapper {
    width: 85%!important;
  }

  .bottom-subtitle1-text-wrapper {
    line-height: 1.7!important;
  }
  .bottom-subtitle2-text-wrapper {
    line-height: 1.7!important;
  }
  .bottom-subtitle-text {
    font-size: 14px!important;
  }

  .bottom-title-text {
    line-height: 1.17!important;
  }
}

.intro-wrapper {
  display: table;
  width: 75%;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.intro-content {
  display: table-cell;
  text-align: center;
}

.intro-subtitle-text-wrapper {
  margin-top: 4rem;
  line-height: 2;
}

.intro-subtitle-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #2c2c2c;
}

.apps-cards-wrapper {
  margin-top: 4rem;
  padding-bottom: 4rem;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.apps-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;
  grid-auto-rows: minmax(100px, auto);
}

.apps-card-grid-column {
  margin-left: auto;
  margin-right: auto;
}

.apps-card {
  max-width: 25rem;
  border-radius: 1.6rem;
  background-color: #ffffff;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);
}

.apps-card-image {
  border-top-left-radius: 1.6rem;
  border-top-right-radius: 1.6rem;
}

.apps-card-content {
  padding: 2rem;
}

.apps-card-title-wrapper {

}

.apps-card-title {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: normal;
  color: #000000;
}

.apps-card-text-wrapper {
  margin-top: 1rem;
  height: 3rem;
}

.apps-card-text {
  font-family: CenturyGothic;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.53;
  letter-spacing: normal;
}

.text-guitar {
  color: #ff9a19;
}

.text-piano {
  color: #2588ff;
}

.text-drums {
  color: #ff5454;
}

.text-bmp {
  color: #ff297f;
}

.apps-card-badges-wrapper {
  margin-top: 1.5rem;
}

.apps-card-badges {

}

.app-card-badge {
  cursor: pointer;
}

.bottom-wrapper {
  display: table;
  width: 65%;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
  text-align: center;
}

.bottom-title-text-wrapper {
  margin-top: 4rem;
}

.bottom-title-text {
  font-family: CenturyGothic;
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.53;
  letter-spacing: normal;
  text-align: center;
  color: #9017ff;
}

.bottom-subtitle1-text-wrapper {
  margin-top: 2rem;
  line-height: 2;
}

.bottom-subtitle2-text-wrapper {
  margin-top: 2rem;
  line-height: 2;
  padding-bottom: 4rem;
}

.bottom-subtitle-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #2c2c2c;
}

</style>
